// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"379":"e813efef","707":"e813efef","852":"e9ee88e3"}[chunkId] + ".chunk.css";
};